module.exports = __webpack_public_path__ + "img/telephone-outbound-fill.8e04f12d.svg";